import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';
import { BestAndLeastSellingProduct } from '../pages/reports/sales/dto/BestAndLeastSellingProduct.model';
import { BestCustomer } from '../pages/reports/sales/dto/BestCustomer.model';
import { Sale } from '../models/sale.model';
import { CreatedSaleResultDto } from '../models/thermal-receipt.model';

@Injectable({
  providedIn: 'root'
})
export class SaleService {
  private readonly baseUrl = `${environment.base_url}/sales`;

  constructor(private http: HttpClient) {}

  getAll(search: string, initialDate: Date, finalDate: Date, canceled: boolean | null, page: number): Observable<RestResponse<Sale[]>> {
    return this.http.get<RestResponse<Sale[]>>(
      `${this.baseUrl}/list?search=${search}&initialDate=${initialDate.toISOString()}&finalDate=${finalDate.toISOString()}&canceled=${canceled}&page=${page}`);
  }

  getById(id: number): Observable<Sale> {
    return this.http.get<Sale>(`${this.baseUrl}/find/${id}`);
  }

  create(sale: Sale): Observable<RestResponse<CreatedSaleResultDto>> {
    return this.http.post<RestResponse<CreatedSaleResultDto>>(`${this.baseUrl}/create`, sale);
  }

  update(id: number, customer: Sale): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, customer);
  }

  cancel(id: number): Observable<RestResponse<Sale>>
  {
    return this.http.patch<RestResponse<Sale>>(`${this.baseUrl}/cancel/${id}`, null);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  export(search: string, initialDate: Date, finalDate: Date, canceled: boolean | null): Observable<Blob> {
    return this.http.get<Blob>(
      `${this.baseUrl}/reports/export-list?search=${search}&initialDate=${initialDate.toISOString()}&finalDate=${finalDate.toISOString()}&canceled=${canceled}`, {
        responseType: 'blob' as 'json'
      }
    );
  }

  exportGet(saleId: number): Observable<Blob> {
    return this.http.get<Blob>(`${this.baseUrl}/reports/export/get/${saleId}`, {responseType: 'blob' as 'json'});
  }

  getBestAndLeastSold(type: string, initialDate: Date, finalDate: Date, page: number): Observable<RestResponse<BestAndLeastSellingProduct[]>> {
    return this.http.get<RestResponse<BestAndLeastSellingProduct[]>>(
      `${this.baseUrl}/reports/best-or-least-sold-items?type=${type}&initialDate=${initialDate.toISOString()}&finalDate=${finalDate.toISOString()}&page=${page}`);
  }

  exportBestAndLeastSold(type: string, initialDate: Date, finalDate: Date): Observable<Blob> {
    return this.http.get<Blob>(
      `${this.baseUrl}/reports/export/best-or-least-sold-items?type=${type}&initialDate=${initialDate.toISOString()}&finalDate=${finalDate.toISOString()}`,
      {responseType: 'blob' as 'json'}
    );
  }

  getBestCustomers(initialDate: Date, finalDate: Date, page: number): Observable<RestResponse<BestCustomer[]>> {
    return this.http.get<RestResponse<BestCustomer[]>>(
      `${this.baseUrl}/reports/best-customers?initialDate=${initialDate.toISOString()}&finalDate=${finalDate.toISOString()}&page=${page}`);
  }

  exportBestCustomers(initialDate: Date, finalDate: Date): Observable<Blob> {
    return this.http.get<Blob>(
      `${this.baseUrl}/reports/export/best-customers?initialDate=${initialDate.toISOString()}&finalDate=${finalDate.toISOString()}`,
      {responseType: 'blob' as 'json'}
    );
  }
}
